module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Faire une demande d\u0027admission":"Apply for admission"}}')
  delete Component.options._Ctor
}
